import React from "react";
import { useTranslation } from "react-i18next";

export default function TechnicalSkillsSection() {
  const { t } = useTranslation();
  const capItems = t('services.capabilities.items', { returnObjects: true });

  return (
    <section id="techstack" className="engagement-section">
      <div className="container py-5">
        <div className="section-sticky-head text-center">
          <div className="section-eyebrow section-eyebrow--center">{t('nav.techstack')}</div>
          <h2 className="capabilities-title">{t('services.capabilities.title')}</h2>
        </div>
        <div className="capabilities-box">
          <p className="capabilities-subtitle mb-0">{t('services.capabilities.subtitle')}</p>
          <ul className="capabilities-list">
            {Array.isArray(capItems) && capItems.map((item, i) => {
              const colon = item.indexOf(':');
              if (colon === -1) return <li key={i}>{item}</li>;
              return (
                <li key={i}>
                  <strong>{item.slice(0, colon)}:</strong>{item.slice(colon + 1)}
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </section>
  );
}
